import axios from "axios";

export const fetchGames = () =>
  axios.get(`${process.env.REACT_APP_API_URL}/game`);

export const fetchRandomGames = () =>
  axios.get(`${process.env.REACT_APP_API_URL}/game/randomgames`);

export const fetchGameImages = id =>
  axios.get(`${process.env.REACT_APP_API_URL}/game/images/${id}`);